import { Action } from "redux";
import { Subscription } from "../../../service/api-response/SubscriptionsSuccessResponse";

export const GET_SUBSCRIPTION_LIST_FOR_USER_SUCCESS =
  "SUBSCRIPTION:GET_SUBSCRIPTION_LIST_FOR_USER_SUCCESS";

export interface GetSubscriptionListForUserSuccess extends Action {
  type: typeof GET_SUBSCRIPTION_LIST_FOR_USER_SUCCESS;
  organizationKeyName: string;
  userId: number;
  subscriptions: Subscription[];
}

export const getSubscriptionListForUserSuccess = (
  organizationKeyName: string,
  userId: number,
  subscriptions: Subscription[]
): GetSubscriptionListForUserSuccess => ({
  type: GET_SUBSCRIPTION_LIST_FOR_USER_SUCCESS,
  organizationKeyName,
  userId,
  subscriptions,
});
